import { IconChevronRight } from "@tabler/icons-react";
import css from "./AssistantDock.module.scss";

// The idle face: what the dock looks like before a session starts. The orb is
// a sibling, not a child, so it survives the morph into the bar untouched.
const DockPillFace = ({ hidden, isMinimized, onOpen, onMinimize }) => (
  <div className={css.pillFace} aria-hidden={hidden}>
    <button
      type="button"
      className={css.pillAction}
      aria-label="Start voice conversation"
      disabled={hidden}
      tabIndex={hidden ? -1 : 0}
      onClick={onOpen}
    >
      <span className={css.pillLabel}>Assistant</span>
    </button>
    <button
      type="button"
      className={css.minimizeAction}
      aria-label="Minimize assistant launcher"
      disabled={hidden || isMinimized}
      tabIndex={hidden || isMinimized ? -1 : 0}
      onClick={onMinimize}
    >
      <IconChevronRight size={15} stroke={2} />
    </button>
  </div>
);

export default DockPillFace;
